import { signUp, find, confirm, add, getQuickPayToken, signUpToken } from "api/accounts";
import tryParseNumber from "../../utils/tryParseNumber";
/* Wrapper for all ajax activity for Account Validation */
class ValidationRepository {
    /**
     * Confirms creation of a new account with reference number and pin
     *
     * @method confirmNewAccount
     * @param {Object} acctCredentials Information to send with request
     * @returns {axios.Promise}
     */
    confirmNewAccount(acctCredentials) {
        return signUp(acctCredentials).then(({ data }) => data);
    }
    confirmNewAccountToken(token, captchaResponse) {
        return signUpToken(token, captchaResponse).then(({ data }) => data);
    }
    getQuickPayToken(referenceNumber, pin, channel) {
        return getQuickPayToken(referenceNumber, pin, channel).then(({ data }) => data);
    }
    /**
     * Confirms addition of an account with reference number and pin
     *
     * @method confirmAddAccount
     * @param {Object} acctCredentials Information to send with request
     * @returns {axios.Promise}
     */
    confirmAddAccount(acctCredentials) {
        return find(tryParseNumber(acctCredentials.referenceNumber), tryParseNumber(acctCredentials.pin)).then(({ data }) => data);
    }
    /**
     * Validates new account with provided info
     *
     * @method validateNewAccount
     * @param {Object} validationInfo Information to send with request
     * @returns {axios.Promise}
     */
    validateNewAccount(validationInfo) {
        return confirm(validationInfo).then(({ data }) => data);
    }
    /**
     * Validates added account with provided info
     *
     * @method validateAddAccount
     * @param {Object} validationInfo Information to send with request
     * @returns {axios.Promise}
     */
    validateAddAccount(validationInfo) {
        return add(validationInfo).then(({ data }) => data);
    }
}
export default new ValidationRepository();



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/validation/ValidationRepository.ts